import { Component, EventEmitter, inject, Output } from "@angular/core";
import { CommonModule } from "@angular/common";
import { IconButtonComponent } from "@vg-constellation/angular-17/button";
import { SpinnerComponent } from "@vg-constellation/angular-17/spinner";
import { GlobalStateStore } from "@services/global-state/global-state.service";
import * as constants from "../../services/content/content";

// Bootstrap Modal type definitions
interface BootstrapModal {
  hide(): void;
  show(): void;
  toggle(): void;
  dispose(): void;
}

interface BootstrapStatic {
  Modal: {
    getInstance(element: HTMLElement): BootstrapModal | null;
    getOrCreateInstance(element: HTMLElement): BootstrapModal;
  };
}

declare const bootstrap: BootstrapStatic;

// Time to wait for Bootstrap modal close animation before opening the next modal
const MODAL_TRANSITION_DELAY = 300; // milliseconds

@Component({
  selector: "app-save-status-modal",
  standalone: true,
  imports: [CommonModule, IconButtonComponent, SpinnerComponent],
  templateUrl: "./save-status-modal.component.html",
  styleUrls: ["./save-status-modal.component.scss"],
})

//TODO: We need to refactor the syncing modal from bootstrap to constellation.
//      We will need to take into account being able to close the modal while syncing when we do this refactor
//      since the we can't remove the exit button from the constellation modal
export class SaveStatusModalComponent {
  @Output() modalClosed = new EventEmitter<void>();

  readonly globalStore = inject(GlobalStateStore);
  constants = constants;

  /**
   * Closes the Bootstrap modal and emits event after transition completes.
   * The delay ensures the Bootstrap modal animation finishes before the next modal opens.
   */
  close(): void {
    const modalEl = document.getElementById("sync-status-modal");
    if (modalEl) {
      const modal = bootstrap.Modal.getInstance(modalEl);
      if (modal) {
        modal.hide();

        // Wait for Bootstrap modal close animation to complete
        setTimeout(() => {
          this.modalClosed.emit();
        }, MODAL_TRANSITION_DELAY);
      }
    }
  }
}
